/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React from 'react';
import strings from "../../../../globalization";
import PopupHeader from '../PopupHeader';
import classes from './About.module.css';

const About = (props) => {
    const {
        storeName = '',
        buildVersion = '',
        supportNumber = '',
        onClose,
        baseUrl = '',
        rnDevEnv = false,
        deviceName = '',
    } = props;

    const getEnv = () => {
        const envMode = process.env.REACT_APP_MODE;
        switch (envMode) {
            case 'DEV': return 'Development';
            case 'UAT': return 'UAT';
            case 'STAGE': return 'Stage';
            default: return 'Production';
        }
    }

    const config = [
        { label: strings.storeName, value: storeName, display: true, },
        { label: strings.deviceName, value: deviceName, display: true, },
        { label: strings.webVersion, value: buildVersion, display: (window.ReactNativeWebView && rnDevEnv) || (!window.ReactNativeWebView), },
        { label: strings.environment, value: getEnv(), display: true, },
        { label: strings.supportCall, value: supportNumber, display: true, },
        { label: strings.url, value: baseUrl, display: window.ReactNativeWebView && rnDevEnv, },
    ]

    return (
        <div className={classes.container}>
            <PopupHeader title={strings.about} onClose={onClose} />
            <div className={classes.itemsContainer}>
                {config.map(each => {
                    return each.display ? (
                        <div className={classes.item}>
                            <span className={classes.labelTextStyle}>{each.label}</span>
                            <span className={classes.valueTextStyle}>{each.value}</span>
                        </div>
                    ) : null
                })}
            </div>
        </div>
    );
};

export default About;
